import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ unlockDate }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(unlockDate));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(unlockDate));
    }, 1000);

    return () => clearInterval(timer);
  }, [unlockDate]);

  function calculateTimeLeft(targetDate) {
    const now = new Date().getTime();
    const target = new Date(targetDate).getTime();
    const difference = target - now;

    if (difference <= 0) {
      return { years: 0, days: 0, hours: 0, minutes: 0, seconds: 0, expired: true };
    }

    const years = Math.floor(difference / (1000 * 60 * 60 * 24 * 365));
    const days = Math.floor((difference % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    return { years, days, hours, minutes, seconds, expired: false };
  }

  if (timeLeft.expired) {
    return (
      <div className="countdown-timer unlocked">
        <span className="countdown-label">🔓 UNLOCKED</span>
      </div>
    );
  }

  return (
    <div className="countdown-timer">
      {/* <div className="countdown-label">Opens after:</div> */}
      <div className="countdown-values">
        {timeLeft.years > 0 && (
          <span className="time-unit">
            <span className="time-value">{timeLeft.years}</span>
            <span className="time-label">year{timeLeft.years !== 1 ? 's' : ''}</span>
          </span>
        )}
        <span className="time-unit">
          <span className="time-value">{timeLeft.days}</span>
          <span className="time-label">day{timeLeft.days !== 1 ? 's' : ''}</span>
        </span>
        <span className="time-unit">
          <span className="time-value">{String(timeLeft.hours).padStart(2, '0')}</span>
          <span className="time-label">hr</span>
        </span>
        <span className="time-unit">
          <span className="time-value">{String(timeLeft.minutes).padStart(2, '0')}</span>
          <span className="time-label">min</span>
        </span>
        <span className="time-unit">
          <span className="time-value">{String(timeLeft.seconds).padStart(2, '0')}</span>
          <span className="time-label">sec</span>
        </span>
      </div>
    </div>
  );
};

export default CountdownTimer;
